import {combineReducers} from 'redux'
import {WORKFLOW_STREAM_LOADED, NEXT_STEP_LOADED, NEXT_STEP_QUERIED, TODO_STREAM_LOADED, TODO_STATUS_QUERIED, UPDATE_STEP_ACTION_RESET, TODO_CRITERIA_UPDATED, TODO_CRITERIA_RESET} from './actions'
import {CREATE_WORKFLOW_ACTION_UPDATED, UPDATE_WORKFLOW_LABEL_ACTION_UPDATED, UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED, ADD_STEP_ACTION_UPDATED, UPDATE_STEP_ACTION_UPDATED} from './actions'
import {CREATE_WORKFLOW_ACTION_SENT, UPDATE_WORKFLOW_LABEL_ACTION_SENT, UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT, ADD_STEP_ACTION_SENT, UPDATE_STEP_ACTION_SENT} from './actions'

function stream(state = [], action) {
    switch (action.type) {
        case WORKFLOW_STREAM_LOADED:
            return action.stream
        default:
            return state
    }
}

function nextStep(state = null, action) {
    switch (action.type) {
        case NEXT_STEP_LOADED:
        case NEXT_STEP_QUERIED:
            return action.nextStep
        default:
            return state
    }
}

function createWorkflowAction(state = null, action) {
    switch (action.type) {
        case CREATE_WORKFLOW_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_WORKFLOW_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateWorkflowLabelAction(state = null, action) {
    switch (action.type) {
        case UPDATE_WORKFLOW_LABEL_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_WORKFLOW_LABEL_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateIdentifiedRequestsAction(state = null, action) {
    switch (action.type) {
        case UPDATE_IDENTIFIED_REQUESTS_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_IDENTIFIED_REQUESTS_ACTION_SENT:
            return null
        default:
            return state
    }
}

function addStepAction(state = null, action) {
    switch (action.type) {
        case ADD_STEP_ACTION_UPDATED:
            return {...state, ...action.action}
        case ADD_STEP_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateStepAction(state = null, action) {
    switch (action.type) {
        case UPDATE_STEP_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_STEP_ACTION_RESET:
            return action.action
        case UPDATE_STEP_ACTION_SENT:
            return null
        default:
            return state
    }
}

const todo = (function() {

    function stream(state = [], action) {
        switch (action.type) {
          case TODO_STREAM_LOADED:
              return action.stream
          default:
              return state
        }
    }

    function aggregations(state = null, action) {
        switch (action.type) {
            case TODO_STREAM_LOADED:
                return action.aggregations
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
          case TODO_STREAM_LOADED:
              return action.range
          default:
              return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case TODO_STREAM_LOADED:
                return action.query
            default:
                return state
        }
    }

    function criteria(state = null, action) {
        switch (action.type) {
            case TODO_CRITERIA_UPDATED:
                return {...state, ...action.criteria}
            case TODO_CRITERIA_RESET:
                return action.criteria
            default:
                return state
        }
    }

    function status(state = [], action) {
        switch (action.type) {
            case TODO_STATUS_QUERIED:
                return action.status
            default:
                return state
        }
    }

    return combineReducers({stream, aggregations, range, query, criteria, status})
})()

export default combineReducers({
    todo,
	stream,
    nextStep,
    createWorkflowAction,
    updateWorkflowLabelAction,
    updateIdentifiedRequestsAction,
    addStepAction,
    updateStepAction
})


// WEBPACK FOOTER //
// ./lib/workflow/reducers.js